import MenuManager from '@yooink/youtils/es/MenuManager';
import { Route, Switch } from 'react-router-dom';
import { FaIdBadge } from 'react-icons/fa';
import { OrganizationsRoute } from './Organizations/OrganizationsRoute';

MenuManager.RegisterGroup({
	key: 'b2b',
	name: 'B2B',
	position: 10,
	icon: <FaIdBadge />
});

export function B2bRoute (props) {
	const basePath = props.path || '/b2b';
	const getPath = (path = '') => `${basePath}${path}`;

	return (
		<>
			<Switch>
				<Route
					path={getPath('/organizations')}
					render={() => <OrganizationsRoute path={getPath('/organizations')} />}
				/>
			</Switch>
		</>
	);
}
